// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2BqkV","author":"Table_author__3x2Tp","authorImage":"Table_authorImage__37Q-q","unreadRow":"Table_unreadRow__1GGzI"};